import { AccountManagementAnalytics, AnalyticsDataLayerEvent, AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';

export class AdobeLogoutCompleteEvent implements AnalyticsDataLayerEvent {
  event = AnalyticsEventType.LogoutComplete;
  account = { devicePlatform: 'web', logouts: { value: 1 } } as AccountManagementAnalytics;
  //most global variables are not needed for this event, so we are not subclassing from AdobeBaseEvent
}